import { STATUS_ENUM } from "@/utils/geo"

export default {
    acquired: (state) => {
        // if we have changed the status then location was acquired at some point
        return state.status !== STATUS_ENUM.NONE
    }
}
